/**
 * A11y keyboard navigation (space bar activation) for button links
 */

'use strict';

const Buttons = () => {

  // const buttons = document.querySelectorAll('a.wp-block-button__link');
  const buttons = document.querySelectorAll('[role="button"], [role="menuitem"], a.wp-block-file__button');
  buttons.forEach((button) => {
    button.addEventListener('keydown', buttonKeydownHandler);
  });
  buttons.forEach((button) => {
    button.addEventListener('keyup', buttonKeyupHandler);
  });


  // add target="_blank" to download buttons
  const downloadButtons = document.querySelectorAll(
    '.wp-block-file a'
  );
  if (downloadButtons) {
    // console.log(downloadButtons);
    downloadButtons.forEach((button) => {
      // add the target and rel attributes
      button.setAttribute('target', '_blank');
      button.setAttribute('rel', 'noreferrer noopener');
      // remove the download attribute to mimic the behavior of the text link
      button.removeAttribute('download');
    });
  }

  /**
   * Prevents scrolling with the space key.
   *
   * @param {KeyboardEvent} event
   */
  function buttonKeydownHandler(event) {
    // The action button is activated by space on the keyup event, but the
    // default action for space is already triggered on keydown. It needs to be
    // prevented to stop scrolling the page before activating the button.
    if (event.code === 'Space') {
      event.preventDefault();
    }
  }

  /**
   * Activates the action button with the space key.
   *
   * @param {KeyboardEvent} event
   */
  function buttonKeyupHandler(event) {

    if (event.code === 'Space') {
      event.preventDefault();
      activateButton(event);
    }
  }

  function activateButton(event) {
    window.console.log(event.target.target);
    if (event.target.target) {
      window.open(event.target.href, event.target.target);
    } else {
      window.open(event.target.href, '_self');
    }
  }

};

export default Buttons;
